import z from 'zod';

import { ENTRANCE_POSITION, entranceSchema } from 'modules/shaxmatka';

export const newSchema = z.object({
  startDoor: z.coerce.number(),
  finishDoor: z.coerce.number(),
  flatOfFloor: z.coerce.number(),
  floor: z.coerce.number(),
  buildingId: z.coerce.number(),
  basement: z.coerce.number().optional()
});
export const updateSchema = entranceSchema.pick({ id: true, name: true, orders: true });
export const deleteSchema = z.object({ id: z.coerce.number() });
export const additionSchema = z.object({
  number: z.coerce.string(),
  relativeEntranceId: z.coerce.number(),
  position: z.nativeEnum(ENTRANCE_POSITION),
  floor: z.coerce.number().min(1),
  flatOfFloor: z.coerce.number().min(1),
  basement: z.coerce.number(),
  buildingId: z.coerce.number()
});

export const duplicateSchema = z.object({
  name: z.string(),
  fromId: z.number(),
  relativeEntranceId: z.number(),
  position: z.nativeEnum(ENTRANCE_POSITION)
});

// TYPES
export type NewForm = z.infer<typeof newSchema>;
export type UpdateForm = z.infer<typeof updateSchema>;
export type DeleteForm = z.infer<typeof deleteSchema>;
export type AdditionForm = z.infer<typeof additionSchema>;
export type DuplicateForm = z.infer<typeof duplicateSchema>;
